import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: 600 auto-generated "utility x modifier x city" bill pages.
// They never earned organic clicks and were pure scaled content.
export const Route = createFileRoute("/check-bill/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
